import React from 'react'
import { connect } from 'react-redux'
import { initKeycloakSession } from './actions/keycloak-actions'
import { Route, Switch, withRouter } from 'react-router-dom'
import { Navbar, NavDropdown, MenuItem, Nav } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'
import { get, find } from 'lodash'

import Main from './pages/Main'
import Users from './pages/UserOverview'
import UserDetail from './pages/UserDetail'
import LicenseOverview from './pages/LicenseOverview'
import LicenseDetail from './pages/LicenseDetail'
import ProductOverview from './pages/ProductOverview'
import ProductDetail from './pages/ProductDetail'
import CustomerOverview from './pages/CustomerOverview'
import CustomerDetail from './pages/CustomerDetail'
import GroupOverview from './pages/GroupOverview'
import GroupDetail from './pages/GroupDetail'
import SubsidiaryOverview from './pages/SubsidiaryOverview'
import SubsidiaryDetail from './pages/SubsidiaryDetail'
import OrderOverview from './pages/OrderOverview'
import OrderDetail from './pages/OrderDetail'
import OrderItemLicenses from './pages/OrderItemLicenses'
import NotFound from './pages/NotFound'
import { findMySubsidiaries, setCurrentSubsidiary, handleCurrentSubsidiary } from './actions/currentUser-actions'
import { fetchSetting } from './actions/setting-actions'
import DashboardMain from './pages/Dashboard/index'

// eslint-disable-next-line
let Subsidiary = ({ all, selected }) => {
  let current = find(all, (sub) => sub.ldapId === selected)
  return current ? <span id="selected_subsidiary">{current.name}</span> : <span />
}

let CurrentUser = ({ userName }) => (
  <div>
    <div style={{ display: 'inline-block' }}>
      {userName}
    </div>
    <FontAwesome name="user" size="3x" style={{ verticalAlign: 'middle' }} />
  </div>
)

class App extends React.Component {
  constructor(props) {
    super(props)
    props.initKeycloakSession(props.keycloakSession)
    props.findMySubsidiaries()
    props.handleCurrentSubsidiary()
    props.fetchSetting('helpPageUrl')
  }

  selectSubsidiary(e) {
    this.props.setCurrentSubsidiary(e)
    this.props.history.push('/')
  }

  logout() {
    this.props.onLogout()
  }

  render() {
    return (
      <div>
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>
              <Link to="/">
                <span className="first-half">Boom</span>
                <span className="second-half">licenties</span>
              </Link>
            </Navbar.Brand>
          </Navbar.Header>
          <Nav pullRight>
            <NavDropdown title={<CurrentUser {...this.props} />} className="currentUser" id="current-user">
              <MenuItem id="help" href={this.props.helpSetting.value} target="_blank">
                <FontAwesome name="question-circle" /> Help
              </MenuItem>
              <MenuItem divider />
              <MenuItem id="logout" onSelect={() => this.logout()}>
                <FontAwesome name="power-off" /> Uitloggen
              </MenuItem>
            </NavDropdown>
          </Nav>
        </Navbar>
        <Switch>
          <Route exact path="/" component={Main} />
          <Route exact path="/gebruikers" component={Users} />
          <Route path="/gebruikers/:id" component={UserDetail} />

          <Route exact path="/licenties" component={LicenseOverview} />
          <Route path="/licenties/:id" component={LicenseDetail} />

          <Route exact path="/producten" component={ProductOverview} />
          <Route path="/producten/:id" component={ProductDetail} />

          <Route exact path="/klanten" component={CustomerOverview} />
          <Route path="/klanten/:id" component={CustomerDetail} />

          <Route exact path="/groepen" component={GroupOverview} />
          <Route path="/groepen/:id" component={GroupDetail} />

          <Route exact path="/werkmaatschappijen" component={SubsidiaryOverview} />
          <Route path="/werkmaatschappijen/:id" component={SubsidiaryDetail} />

          <Route exact path="/orders" component={OrderOverview} />
          <Route path="/orders/:id" component={OrderDetail} />

          <Route path="/order/:id/licenses/:navId" component={OrderItemLicenses} />

          <Route exact path="/dashboard" component={DashboardMain} />

          <Route path="*" component={NotFound} />
        </Switch>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    userName: get(state, 'keycloak.tokenParsed.name'),
    subsidiaries: state.currentUser.subsidiaries,
    subsidiary: state.currentUser.subsidiary,
    helpSetting: state.settings.setting,
  }
}

export default withRouter(
  connect(mapStateToProps, {
    initKeycloakSession,
    findMySubsidiaries,
    handleCurrentSubsidiary,
    setCurrentSubsidiary,
    fetchSetting,
  })(App)
)
